import { useSuspenseQuery } from '@tanstack/react-query';
import api from '@/axios';
import type { PurchaseOrderActivityItem } from '@/features/purchase-order/activity/types/purchase-order-activity-item';
import { GET_PURCHASE_ORDER_ACTIVITY_KEY } from '@/keys';

type UsePurchaseOrderActivityParams = {
  purchaseOrderId: string;
};

export function useGetPurchaseOrderActivity({
  purchaseOrderId,
}: UsePurchaseOrderActivityParams) {
  const { data } = useSuspenseQuery({
    queryKey: [...GET_PURCHASE_ORDER_ACTIVITY_KEY, purchaseOrderId],
    queryFn: async () => {
      const response = await api.get<PurchaseOrderActivityItem[]>(
        `/purchase-orders/${purchaseOrderId}/activity`,
      );

      return response.data;
    },
  });

  return {
    data,
  };
}
